import React, { useState } from 'react';
import { Box, Button, Grid, IconButton, MenuItem, Select, Typography, Paper, Radio, RadioGroup, FormControlLabel, TextField, Dialog, DialogTitle, DialogContent, DialogActions, DialogContentText } from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import InputAdornment from '@mui/material/InputAdornment';
import DialogLoader from 'UI/Application/Components/Loaders/DialogLoader';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import Tooltip from '@mui/material/Tooltip';
import propTypes from 'prop-types';
import { getJobPositionsInUseList } from 'JobPosition/Domain/Services/GetJobPositionsInUseListService';
import { useEffect } from 'react';
import { v4 as uuidv4 } from 'uuid';
import { createProposalProjectSavingsStaff } from 'ProposalProject/ProposalProjectSavingsStaff/Domain/Services/CreateProposalProjectSavingsStaffService';
import { deleteProposalProjectSavingsStaff } from 'ProposalProject/ProposalProjectSavingsStaff/Domain/Services/DeleteProposalProjectSavingsStaffService';
import { patchProposalProjectSavingsStaff } from 'ProposalProject/ProposalProjectSavingsStaff/Domain/Services/PatchProposalProjectSavingsStaffService';
import { createProposalProjectCostIT } from 'ProposalProject/ProposalProjectCostIT/Domain/Services/CreateProposalProjectCostITService';
import { patchProposalProjectCostIT } from 'ProposalProject/ProposalProjectCostIT/Domain/Services/PatchProposalProjectCostITService';
import { deleteProposalProjectCostIT } from 'ProposalProject/ProposalProjectCostIT/Domain/Services/DeleteProposalProjectCostITService';
import { patchProposalProject } from 'ProposalProject/ProposalProject/Domain/Services/PatchProposalProjectService';
import { ProposalProjectConstants } from 'ProposalProject/ProposalProject/Domain/Model/ProposalProjectConstant';
import { useAuthContext } from 'Shared/Security/Domain/Contexts/authContext';
import { ADMIN_PROPOSAL_PROJECT } from 'Shared/Security/Application/Constants/PermissionsConstant';
import SearchableSelect from 'UI/Application/Components/Menus/generic/SearchableSelect';

const ThirdStep = ({
    idProposalProject,
    savingsStaffProposalProject,
    costITProposalProject,
    reloadData,
    readOnly = false,
    currentStatus
}) => {
    const { checkPermission } = useAuthContext();

    const [benefitsRows, setBenefitsRows] = useState([]); // Usar un estado vacío al inicio
    

    const [dialogTargetId, setDialogTargetId] = useState(null);
    const [dialogTargetType, setDialogTargetType] = useState(null);
    const [dialogTargetSetRows, setDialogTargetSetRows] = useState(null);

    const [positions, setPositions] = useState([]);
    const [period, setPeriod] = useState([]);
    //const [unit, setUnit] = useState([]);
    const [isDialogOpen, setIsDialogOpen] = useState(false);
    const [newConcept, setNewConcept] = useState('');

    const [savingsRowsSw, setSavingsRowsSw] = useState([]);
    const [savingsRowsHw, setSavingsRowsHw] = useState([]);
    const [savingsRowsSub, setSavingsRowsSub] = useState([]);

    const [typeImport, setTypeImport] = useState([]);
    const [allDescriptions, setAllDescriptions] = useState([]);

    const [sendingApiRequest, setSendingApiRequest] = useState(false);
    const [dataToDelete, setDataToDelete] = useState(null);
    const [openSaveDialog, setOpenSaveDialog] = useState(false);

    const [openDialog, setOpenDialog] = useState(false);
    const [openDialogError, setOpenDialogError] = useState(false);
    
    const headerStyle = {
        backgroundColor: '#0492D4',
        color: 'white',
        p: 1,
        borderRadius: '4px',
        textAlign: 'center',
    };

    async function fetchData() {
        setSendingApiRequest(true);
        if (costITProposalProject) {
            const descriptionsFromProject = costITProposalProject
                .map((row) => row.description) // Extraer las descripciones
                .filter((desc) => desc); // Filtrar descripciones vacías

            const uniqueDescriptions = [...new Set(descriptionsFromProject)]; // Eliminar duplicados
            setAllDescriptions(uniqueDescriptions);
        }

        const mappedRows = (savingsStaffProposalProject || [])
            .filter(row => row.origin === 'F3')
            .map((row) => ({
                ...row,
                id: row.id || uuidv4(), // Si no tiene un ID único, generar uno
                // Normalizamos a string para el UI del SearchableSelect
                jobPosition: row?.jobPosition !== undefined && row?.jobPosition !== null ? String(row.jobPosition) : ''
            }));

        const mappedRowsSw = (costITProposalProject || []).filter(row => row.origin === 'SW').map((row) => ({
            ...row,
            id: row.id || uuidv4(), // Si no tiene un ID único, generar uno
        }));

        const mappedRowsHw = (costITProposalProject || []).filter(row => row.origin === 'HW').map((row) => ({
            ...row,
            id: row.id || uuidv4(), // Si no tiene un ID único, generar uno
        }));

        const mappedRowsSub = (costITProposalProject || []).filter(row => row.origin === 'SUBCONTRACTING').map((row) => ({
            ...row,
            id: row.id || uuidv4(), // Si no tiene un ID único, generar uno
        }));

        setSavingsRowsSw(mappedRowsSw);
        setSavingsRowsHw(mappedRowsHw);
        setSavingsRowsSub(mappedRowsSub);
        setBenefitsRows(mappedRows);
        await getJobPositionsInUseList().then((response) => {
            if (response !== null) {
                setPositions(response.records);
            }
        });

        await fetch('/api/v1/enumsList') 
            .then((response) => response.json())
            .then((data) => {
                setPeriod(data.periodLevel);
                //setUnit(data.unitLevel);
                setTypeImport(data.typeLevel);
            })
        .catch((error) => {
            console.error('Error al obtener los niveles de enums:', error);
        });

        setSendingApiRequest(false);
    }

    useEffect(() => {        
        fetchData();
    }
    , [savingsStaffProposalProject, costITProposalProject]);


    const saveSavingsRows = async (rows, origin, setRows) => {
        try {
            const filteredRows = rows.map((row) => ({
                ...row,
                proposalProject: parseInt(idProposalProject, 10),
                origin,
            }));

            const newSavings = filteredRows.filter((row) => isNaN(row.id));
            const modifiedSavings = filteredRows.filter((row) => {
                const initialRow = costITProposalProject.find((initial) => initial.id === row.id);
                return (
                    initialRow &&
                    (initialRow.description !== row.description ||
                        initialRow.type !== row.type ||
                        initialRow.quantity !== row.quantity ||
                        initialRow.period !== row.period)
                );
            });

            if (modifiedSavings.length > 0) {
                await patchProposalProjectCostIT({ items: modifiedSavings });
            }

            if (newSavings.length > 0) {
                const savingsResponse = await createProposalProjectCostIT({ items: newSavings });
                if (savingsResponse && Array.isArray(savingsResponse)) {
                    setRows((prevRows) =>
                        prevRows.map((row) => {
                            const updatedRow = savingsResponse.find(
                                (item) => item.description === row.description
                            );
                            return updatedRow ? { ...row, id: updatedRow.id } : row;
                        })
                    );
                }
            }
            return true; // éxito
        } catch (error) {
            console.error(`Error al guardar datos para origen ${origin}:`, error);
            return false; // fallo
        }
    };
    
    const handleAddConcept = () => {
        if (!newConcept.trim()) return;
    
        if (dialogTargetType === 'description' && dialogTargetSetRows) {
          setAllDescriptions((prev) => [...prev, newConcept.trim()]);
          dialogTargetSetRows((prevRows) =>
            prevRows.map((row) =>
              row.id === dialogTargetId ? { ...row, description: newConcept.trim() } : row
            )
          );
        }
    
        setNewConcept('');
        setIsDialogOpen(false);
        setDialogTargetId(null);
        setDialogTargetType(null);
        setDialogTargetSetRows(null);
    };


    const handleDialogClose = () => {
        setNewConcept('');
        setIsDialogOpen(false);
        setDialogTargetId(null);
        setDialogTargetType(null);
        setDialogTargetSetRows(null);
    };

    // Agregar fila
    const addBenefitRow = () => {
        setBenefitsRows((prevRows) => [
            ...prevRows,
            { id: uuidv4(), jobPosition: '', user: '', period: '', quantity: ''}
        ]);
    };

    const handleDeleteBenefitRow = async (row) => {
        try {
            
            if (!isNaN(row.id)) {
                await deleteProposalProjectSavingsStaff(row.id);
            }
    
            // Actualizar el estado eliminando el elemento eliminado
            const id = row.id;
            setBenefitsRows((prevRows) => prevRows.filter((row) => row.id !== id));
        } catch (error) {
            //console.error('Error al eliminar el registro:', error);
            alert('No se pudo eliminar el registro. Por favor, intente nuevamente.');
        }
    };

    // Manejar cambios
    const handleBenefitChange = (id, field, value) => {
        setBenefitsRows((prevRows) =>
            prevRows.map((row) => (row.id === id ? { ...row, [field]: value } : row))
        );
    };

    // Función para manejar cambios en una fila específica
    const handleSavingsRowChange = (id, field, value, setRows) => {
        setRows((prevRows) =>
            prevRows.map((row) =>
                row.id === id ? { ...row, [field]: value } : row
            )
        );
    };

    // Función para agregar una nueva fila
    const addRow = (setRows) => {
        setRows((prevRows) => [
            ...prevRows,
            { id: uuidv4(), description: '', type: '', quantity: '', period: '' },
        ]);
    };

    const removeSavingsRow = async (row, origin, setRows) => {
        try {
            // Llamada para eliminar el registro en el backend
            if (!isNaN(row.id)) {
                await deleteProposalProjectCostIT(row.id);
            }
    
            // Actualizar el estado eliminando el elemento eliminado
            setRows((prevRows) => prevRows.filter((r) => r.id !== row.id));
            //console.log(`Fila con ID ${row.id} eliminada exitosamente para origen: ${origin}`);
        } catch (error) {
            console.error(`Error al eliminar la fila con ID ${row.id} para origen: ${origin}`, error);
            alert('No se pudo eliminar el registro. Por favor, intente nuevamente.');
        }
    };
  
    const handleDescriptionChange = (id, value, setRows) => {
      if (value === 'custom') {
        setIsDialogOpen(true);
        setDialogTargetId(id);
        setDialogTargetType('description');
        setDialogTargetSetRows(() => setRows);
      } else {
        setRows((prevRows) =>
          prevRows.map((row) =>
            row.id === id ? { ...row, description: value } : row
          )
        );
      }
    };
    
    const handleSubmit = async (event, workflowAction) => {

        let patchBenefits = true;
        let benefitsResponse = true;
        let patchSavingsSw = true;
        let patchSavingsHw = true;
        let patchSavingsSub = true;

        event.preventDefault();
        const hasEmptyFields = benefitsRows.some(
            (row) => !row.jobPosition || !row.numberOfPeople || !row.period || !row.quantity
        );

        const hasEmptySavingsSw = savingsRowsSw.some(
            (row) => !row.description || !row.type || !row.quantity || (row.type !== 'UNIQUE' && !row.period)
        );

        const hasEmptySavingsHw = savingsRowsHw.some(
            (row) => !row.description || !row.type || !row.quantity || (row.type !== 'UNIQUE' && !row.period)
        );

        const hasEmptySavingsSub = savingsRowsSub.some(
            (row) => !row.description || !row.type || !row.quantity || (row.type !== 'UNIQUE' && !row.period)
        );

        if (hasEmptySavingsSw || hasEmptySavingsHw || hasEmptySavingsSub || hasEmptyFields) {
            setOpenDialogError(true);
            return;
        }

        try {
            // Detectar filas nuevas y modificadas
            benefitsRows.forEach((row) => {
                row.proposalProject = parseInt(idProposalProject);
                row.origin = 'F3';
            });

            const newBenefits = benefitsRows.filter((row) => isNaN(row.id)); // Nuevos beneficios
            const modifiedBenefits = benefitsRows.filter((row) => {
                const initialRow = savingsStaffProposalProject.find((initial) => initial.id === row.id);
                return (
                    initialRow &&
                    (
                        String(initialRow.jobPosition) !== String(row.jobPosition) ||
                        initialRow.numberOfPeople !== row.numberOfPeople ||
                        initialRow.period !== row.period ||
                        initialRow.quantity !== row.quantity
                    )
                );
            });

            // PATCH para filas modificadas
            if (modifiedBenefits.length > 0) {
                const items = modifiedBenefits.map((r) => ({
                    ...r,
                    jobPosition: r.jobPosition ? parseInt(r.jobPosition, 10) : null
                }));
                patchBenefits = await patchProposalProjectSavingsStaff({ items });
            }

            // CREATE para filas nuevas
            if (newBenefits.length > 0) {
                const items = newBenefits.map(({ jobPosition, numberOfPeople, ...rest }) => ({
                    ...rest,
                    jobPosition: jobPosition ? parseInt(jobPosition, 10) : null,
                    numberOfPeople: numberOfPeople === '' ? null : (Number.isInteger(numberOfPeople) ? numberOfPeople : parseInt(numberOfPeople, 10)),
                }));
                benefitsResponse =  await createProposalProjectSavingsStaff({ items });
                if (benefitsResponse && Array.isArray(benefitsResponse)) {
                    // Emparejar por combinación de campos, soportando filas con mismo jobPosition
                    const usedIndexes = new Set();
                    setBenefitsRows((prevRows) =>
                        prevRows.map((row) => {
                            if (!isNaN(row.id)) return row; // ya tenía id
                            const matchIndex = benefitsResponse.findIndex((item, idx) => {
                                if (usedIndexes.has(idx)) return false;
                                return (
                                    item?.jobPosition?.id === Number(row.jobPosition) &&
                                    item.numberOfPeople === (row.numberOfPeople === '' ? null : Number(row.numberOfPeople)) &&
                                    item.period === row.period &&
                                    Number(item.quantity) === Number(row.quantity)
                                );
                            });
                            if (matchIndex !== -1) {
                                usedIndexes.add(matchIndex);
                                return { ...row, id: benefitsResponse[matchIndex].id };
                            }
                            return row;
                        })
                    );
                }
            }

        } catch (error) {
            console.error('Error al guardar los datos:', error);
            alert('Hubo un error al guardar los datos. Por favor, intente nuevamente.');
        }

        if (savingsRowsSw.some(row => row.description && row.type && row.quantity)) {
            patchSavingsSw = await saveSavingsRows(savingsRowsSw, 'SW', setSavingsRowsSw);
        }
        
        if (savingsRowsHw.some(row => row.description && row.type && row.quantity)) {
            patchSavingsHw = await saveSavingsRows(savingsRowsHw, 'HW', setSavingsRowsHw);
        }
        
        if (savingsRowsSub.some(row => row.description && row.type && row.quantity)) {
            patchSavingsSub = await saveSavingsRows(savingsRowsSub, 'SUBCONTRACTING', setSavingsRowsSub);
        }

        if (workflowAction === null) {
            // Todos los patch* serán true o se quedaron en true si no había filas que procesar; si alguno es false no mostramos el diálogo
            if (patchBenefits && patchSavingsSw && patchSavingsHw && patchSavingsSub) {
                setOpenSaveDialog(true);
                reloadData();
            }
        }

        var workflowResponse = null;
        if (workflowAction !== null) {
            workflowResponse = await patchProposalProject(parseInt(idProposalProject), {
                workflowAction: workflowAction
            });
        } else {
            workflowResponse = true;
        }

        if (workflowResponse && workflowAction !== null) {
            // En transiciones de workflow sólo recargamos
            reloadData();
        }


    };

    const handleCloseSaveDialog = () => setOpenSaveDialog(false);

    // Abre el dialog para confirmar eliminación
    const confirmDelete = (data, type) => {
        const dataWithType = { ...data, type: type };
        setDataToDelete(dataWithType);        
        setOpenDialog(true);
    };

    const handleConfirmDelete = async () => {
        if (dataToDelete && dataToDelete.type === 'benefits') {
            setSendingApiRequest(true);
            const result = handleDeleteBenefitRow(dataToDelete);
            if (result) {
                setSendingApiRequest(false);
                setOpenDialog(false);
                setDataToDelete(null);
            }
        }

        if (dataToDelete && dataToDelete.type === 'savingsSw') {
            setSendingApiRequest(true);
            const result = removeSavingsRow(dataToDelete, dataToDelete.origin, setSavingsRowsSw);
            if (result) {
                setSendingApiRequest(false);
                setOpenDialog(false);
                setDataToDelete(null);
            }
        }

        if (dataToDelete && dataToDelete.type === 'savingsHw') {
            setSendingApiRequest(true);
            const result = removeSavingsRow(dataToDelete, dataToDelete.origin, setSavingsRowsHw);
            if (result) {
                setSendingApiRequest(false);
                setOpenDialog(false);
                setDataToDelete(null);
            }
        }

        if (dataToDelete && dataToDelete.type === 'savingsSub') {
            setSendingApiRequest(true);
            const result = removeSavingsRow(dataToDelete, dataToDelete.origin, setSavingsRowsSub);
            if (result) {
                setSendingApiRequest(false);
                setOpenDialog(false);
                setDataToDelete(null);
            }
        }
    };

    const handleCloseDialog = () => {
        setOpenDialog(false);
        setOpenDialogError(false);
        setDataToDelete(null);
    };

    // Add a function to conditionally render action buttons
    const renderActionButtons = () => {
        // If in read-only mode, show a message instead of buttons
        if (readOnly) {
            return (
                <>
                    <Typography variant="h6" mt={4} color="textSecondary">
                        Vista en modo de solo lectura.
                    </Typography>
                    <Typography variant="h6" mt={4} color="textSecondary">
                        {currentStatus !== undefined && currentStatus && 
                        `La propuesta no está en este estado.`}
                    </Typography>
                </>
            );
        }

        // Normal buttons when not in read-only mode
        return (
            <div style={{ display: 'flex', justifyContent: 'center', marginTop: '20px' }}>
                {checkPermission(ADMIN_PROPOSAL_PROJECT) ? (  
                    <>
                        <Button 
                            variant="contained" 
                            type="submit" 
                            style={{ marginTop: '35px', marginRight: '10px' }}
                            onClick={(e) => handleSubmit(e, ProposalProjectConstants.WORKFLOW_ADMIN_TO_USER)}
                        >
                            Volver
                        </Button>
                        
                        <Button 
                            variant="contained" 
                            type="submit" 
                            style={{ marginTop: '35px', marginRight: '10px' }}
                            onClick={(e) => handleSubmit(e, null)}
                        >
                            Guardar
                        </Button>

                        <Button 
                            variant="contained" 
                            type="submit" 
                            style={{ marginTop: '35px' }}
                            onClick={(e) => handleSubmit(e, ProposalProjectConstants.WORKFLOW_STEP3_TO_STEP4)}
                        >
                            Siguiente Paso
                        </Button>
                    </>
                ) : (
                    <span>La propuesta se encuentra en fase de revisión. No se pueden realizar cambios.</span>
                )}
            </div>
        );
    };

    return (
        <div style={{ backgroundColor: '#f5f5f5', padding: '20px', borderRadius: '8px', textAlign: 'center', marginTop: '20px', border: '1px solid #ccc' }}>
            <Box sx={{ p: 4 }}>
                {/* Beneficios */}
                <Box sx={{ mb: 2, width: "100%", textAlign: "center", display: "flex", flexDirection: "column", alignItems: "center" }}>
                    <Typography variant="h6" mb={1}>Costes de implantación</Typography>
                    <Tooltip
                        title={
                            <Box sx={{ p: 1 }}>
                                <Typography variant="text" sx={{ fontWeight: 'bold', mb: 0.5 }}>
                                    El objetivo de este bloque es registrar los costes de personal para la implantación del proyecto.
                                </Typography>
                                <br />
                                <br />
                                <Typography variant="text" sx={{ fontWeight: 'bold', mb: 0.5 }}>
                                    Ejemplo: 2 técnicos de desarrollo necesarios durante 3 meses para la implantación.
                                </Typography>
                                <br />
                                <br />
                                <Typography variant="text" sx={{ fontWeight: 'bold', mb: 0.5 }}>
                                    Información sobre los campos:
                                </Typography>
                                <ul style={{ margin: '0', paddingLeft: '16px' }}>
                                    <li><b>Puestos:</b> Perfiles necesarios para la implantación</li>
                                    <li><b>Personas:</b> Número de personas requeridas por perfil</li>
                                    <li><b>Periodo Tiempo:</b> Unidad de tiempo (días/semanas/meses)</li>
                                    <li><b>Cantidad Tiempo:</b> Valor numérico del tiempo necesario</li>
                                </ul>
                            </Box>
                        }
                        arrow
                        placement="right"
                        sx={{ maxWidth: '400px' }}
                    >
                        <Box display="flex" alignItems="center" justifyContent="center">
                            <Typography variant="caption" color="primary" sx={{  }}>¿Tienes dudas?</Typography>
                            <IconButton size="small" color="primary">
                                <HelpOutlineIcon fontSize="small" />
                            </IconButton>
                        </Box>
                    </Tooltip>
                </Box>
                <Paper sx={{ p: 2, backgroundColor: '#e0f7fa', boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.1)' }}>
                    <Grid container spacing={2} mb={2}>
                        <Grid item xs={3}>
                            <Typography variant="subtitle2" sx={headerStyle}>Puestos</Typography>
                        </Grid>
                        <Grid item xs={3}>
                            <Typography variant="subtitle2" sx={headerStyle}>Personas</Typography>
                        </Grid>
                        <Grid item xs={3}>
                            <Typography variant="subtitle2" sx={headerStyle}>Periodo Tiempo</Typography>
                        </Grid>
                        <Grid item xs={!readOnly && checkPermission(ADMIN_PROPOSAL_PROJECT) ? 2 : 3}>
                            <Typography variant="subtitle2" sx={headerStyle}>Cantidad Tiempo</Typography>
                        </Grid>
                        {!readOnly && checkPermission(ADMIN_PROPOSAL_PROJECT) && (
                            <Grid item xs={1} display="flex" justifyContent="center" alignItems="center">
                                <IconButton size="small" onClick={addBenefitRow}>
                                    <AddCircleOutlineIcon color="primary" />
                                </IconButton>
                            </Grid>
                        )}
                    </Grid>

                    {benefitsRows.map((row) => (
                        <Grid container spacing={2} key={row.id} mb={1}>
                            <Grid item xs={3}>
                            <SearchableSelect
                                options={positions}
                                value={row.jobPosition}
                                onChange={(e) => handleBenefitChange(row.id, 'jobPosition', e.target.value)}
                                disabled={readOnly}
                                placeholder="Seleccione un puesto"
                                renderOption={(option) => option.name}
                            />
                            </Grid>
                            <Grid item xs={3}>
                                <TextField
                                    fullWidth
                                    size="small"
                                    value={row.numberOfPeople || ""}
                                    onChange={(e) => {
                                        const value = e.target.value;
                                        // Solo permitir números enteros positivos
                                        if (value === '' || /^[1-9]\d*$/.test(value)) {
                                            const intValue = value === '' ? '' : parseInt(value, 10);
                                            handleBenefitChange(row.id, 'numberOfPeople', intValue);
                                        }
                                    }}
                                    placeholder="Número de personas"
                                    inputProps={{
                                        inputMode: 'numeric',
                                        pattern: '[1-9][0-9]*',
                                        min: "1"
                                    }}
                                    disabled={readOnly}
                                    helperText="Mínimo 1 persona"
                                />
                            </Grid>
                            <Grid item xs={3}>
                                <Select
                                    fullWidth
                                    size="small"
                                    value={row.period}
                                    onChange={(e) => handleBenefitChange(row.id, 'period', e.target.value)}
                                    disabled={readOnly}
                                >
                                    <MenuItem value=""><em>Seleccione una opción</em></MenuItem>
                                    {period.map((p) => (
                                        <MenuItem key={p.key} value={p.key}>{p.value}</MenuItem>
                                    ))}
                                </Select>
                            </Grid>
                            <Grid item xs={readOnly ? 3 : 2}>
                            <TextField
                                fullWidth
                                size="small"
                                value={row.quantity}
                                onChange={(e) => {
                                    const value = e.target.value;
                                    // Convierte el valor a float si es válido, de lo contrario usa 0 o null
                                    const floatValue = value === '' ? null : parseFloat(value) || 0;
                                    handleBenefitChange(row.id, 'quantity', floatValue);
                                }}
                                placeholder="Escribe un número"
                                inputProps={{
                                    inputMode: 'decimal', // Sugerencia de teclado numérico
                                    pattern: "^\\d*\\.?\\d*$", // Validación en el lado del cliente
                                }}
                                disabled={readOnly}
                            />

                            </Grid>
                            {!readOnly && checkPermission(ADMIN_PROPOSAL_PROJECT) && (
                                <Grid item xs={1} display="flex" justifyContent="center" alignItems="center">
                                    <IconButton size="small" onClick={() => confirmDelete(row,'benefits')}>
                                        <DeleteIcon color="error" />
                                    </IconButton>
                                </Grid>
                            )}
                        </Grid>
                    ))}
                </Paper>

                {/* Coste Software */}
                <Typography variant="h6" mt={4} mb={2}>
                    Coste Software
                </Typography>
                <Box sx={{ mb: 2, width: "100%", textAlign: "center", display: "flex", flexDirection: "column", alignItems: "center" }}>
                    <Tooltip
                        title={
                            <Box sx={{ p: 1 }}>
                                <Typography variant="text" sx={{ fontWeight: 'bold', mb: 0.5 }}>
                                    El objetivo de este bloque es registrar los costes de software necesarios para la implementación del proyecto.
                                </Typography>
                                <br />
                                <br />
                                <Typography variant="text" sx={{ fontWeight: 'bold', mb: 0.5 }}>
                                    Ejemplo: Licencia de software de gestión por 500€ al mes.
                                </Typography>
                                <br />
                                <br />
                                <Typography variant="text" sx={{ fontWeight: 'bold', mb: 0.5 }}>
                                    Información sobre los campos:
                                </Typography>
                                <ul style={{ margin: '0', paddingLeft: '16px' }}>
                                    <li><b>Descripción:</b> Nombre o descripción del software</li>
                                    <li><b>Tipo Importe:</b> Si el coste es único o recurrente</li>
                                    <li><b>Cantidad Importe:</b> Valor económico del software</li>
                                    <li><b>Periodo Tiempo:</b> En caso de ser recurrente, frecuencia del pago</li>
                                </ul>
                            </Box>
                        }
                        arrow
                        placement="right"
                        sx={{ maxWidth: '400px' }}
                    >
                        <Box display="flex" alignItems="center" justifyContent="center">
                            <Typography variant="caption" color="primary">¿Tienes dudas?</Typography>
                            <IconButton size="small" color="primary">
                                <HelpOutlineIcon fontSize="small" />
                            </IconButton>
                        </Box>
                    </Tooltip>
                </Box>
                <Paper sx={{ p: 2, backgroundColor: '#e0f7fa', boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.1)' }}>
                    <Grid container spacing={2} mb={2}>
                        <Grid item xs={3}>
                            <Typography variant="subtitle2" sx={headerStyle}>Descripción</Typography>
                        </Grid>
                        <Grid item xs={3}>
                            <Typography variant="subtitle2" sx={headerStyle}>Tipo Importe</Typography>
                        </Grid>
                        <Grid item xs={3}>
                            <Typography variant="subtitle2" sx={headerStyle}>Cantidad Importe</Typography>
                        </Grid>
                        <Grid item xs={!readOnly && checkPermission(ADMIN_PROPOSAL_PROJECT) ? 2 : 3}>
                            <Typography variant="subtitle2" sx={headerStyle}>Periodo Tiempo</Typography>
                        </Grid>
                        {!readOnly && checkPermission(ADMIN_PROPOSAL_PROJECT) ? (
                            <Grid item xs={1} display="flex" justifyContent="center" alignItems="center">
                                <IconButton size="small" onClick={() => addRow(setSavingsRowsSw, { description: '', type: 'Único', quantity: '', period: '' })}>
                                    <AddCircleOutlineIcon color="primary" />
                                </IconButton>
                            </Grid>
                        ) : null}
                    </Grid>

                    {savingsRowsSw.map((row) => (
                        <Grid container spacing={2} key={row.id} mb={1}>
                            <Grid item xs={3}>
                            <SearchableSelect
                                options={[...allDescriptions.map((desc) => ({ value: desc })), { value: 'custom' }]}
                                value={row.description}
                                onChange={(e) => handleDescriptionChange(row.id, e.target.value, setSavingsRowsSw)}
                                disabled={readOnly}
                                placeholder="Seleccione una opción"
                                renderOption={(option) =>
                                    option.value === 'custom' ? <em>Escribir concepto</em> : option.value
                                }
                            />
                            </Grid>
                            <Grid item xs={3}>
                                <RadioGroup
                                    row
                                    value={row.type}
                                    onChange={(e) => {
                                        const newValue = e.target.value;
                                        handleSavingsRowChange(row.id, 'type', newValue, setSavingsRowsSw);
                                        if (newValue === 'UNIQUE') {
                                            handleSavingsRowChange(row.id, 'period', '', setSavingsRowsSw);
                                        }
                                    }}   
                                >
                                    {typeImport.map((p) => (
                                        <FormControlLabel disabled={readOnly} key={p.key} value={p.key} control={<Radio />} label={p.value} />
                                    ))}
                                </RadioGroup>
                            </Grid>
                            <Grid item xs={3}>
                                <TextField
                                    fullWidth
                                    size="small"
                                    value={row.quantity}
                                    onChange={(e) => {
                                        const value = e.target.value;
                                        const floatValue = value === '' ? null : parseFloat(value) || 0;
                                        handleSavingsRowChange(row.id, 'quantity', floatValue, setSavingsRowsSw);
                                    }}
                                    placeholder="Escribe un número"
                                    inputProps={{
                                        inputMode: 'decimal', // Sugerencia de teclado numérico para dispositivos móviles
                                        pattern: "^\\d*\\.?\\d*$", // Correcta forma en cadenas JavaScript
                                    }}
                                    InputProps={{
                                        endAdornment: (
                                            <InputAdornment position="end">€</InputAdornment>
                                        ),
                                    }}
                                    disabled={readOnly}
                                />

                            </Grid>
                            <Grid item xs={readOnly ? 3 : 2}>
                                <Select
                                    fullWidth
                                    size="small"
                                    value={row.period}
                                    onChange={(e) => handleSavingsRowChange(row.id, 'period', e.target.value, setSavingsRowsSw)}
                                    disabled={row.type === 'UNIQUE' || readOnly}
                                >
                                    <MenuItem value=""><em>Seleccione una opción</em></MenuItem>
                                    {period.map((p) => (
                                        <MenuItem key={p.key} value={p.key}>{p.value}</MenuItem>
                                    ))}
                                </Select>
                            </Grid>
                            {!readOnly && checkPermission(ADMIN_PROPOSAL_PROJECT) && (
                            <Grid item xs={1} display="flex" justifyContent="center" alignItems="center">
                                <IconButton size="small" onClick={() => confirmDelete(row,'savingsSw')}>
                                    <DeleteIcon color="error" />
                                </IconButton>
                            </Grid>
                            )}
                        </Grid>
                    ))}
                </Paper>

                {/* Coste Hardware */}
                <Typography variant="h6" mt={4} mb={2}>
                    Coste Hardware
                </Typography>
                <Box sx={{ mb: 2, width: "100%", textAlign: "center", display: "flex", flexDirection: "column", alignItems: "center" }}>
                    <Tooltip
                        title={
                            <Box sx={{ p: 1 }}>
                                <Typography variant="text" sx={{ fontWeight: 'bold', mb: 0.5 }}>
                                    El objetivo de este bloque es registrar los costes de hardware necesarios para la implementación del proyecto.
                                </Typography>
                                <br />
                                <br />
                                <Typography variant="text" sx={{ fontWeight: 'bold', mb: 0.5 }}>
                                    Ejemplo: Compra de servidores dedicados por 2.000€ o alquiler de hosting por 150€ al mes.
                                </Typography>
                                <br />
                                <br />
                                <Typography variant="text" sx={{ fontWeight: 'bold', mb: 0.5 }}>
                                    Información sobre los campos:
                                </Typography>
                                <ul style={{ margin: '0', paddingLeft: '16px' }}>
                                    <li><b>Descripción:</b> Nombre o descripción del hardware</li>
                                    <li><b>Tipo Importe:</b> Si el coste es único o recurrente</li>
                                    <li><b>Cantidad Importe:</b> Valor económico del hardware</li>
                                    <li><b>Periodo Tiempo:</b> En caso de ser recurrente, frecuencia del pago</li>
                                </ul>
                            </Box>
                        }
                        arrow
                        placement="right"
                        sx={{ maxWidth: '400px' }}
                    >
                        <Box display="flex" alignItems="center" justifyContent="center">
                            <Typography variant="caption" color="primary">¿Tienes dudas?</Typography>
                            <IconButton size="small" color="primary">
                                <HelpOutlineIcon fontSize="small" />
                            </IconButton>
                        </Box>
                    </Tooltip>
                </Box>
                <Paper sx={{ p: 2, backgroundColor: '#e0f7fa', boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.1)' }}>
                    <Grid container spacing={2} mb={2}>
                        <Grid item xs={3}>
                            <Typography variant="subtitle2" sx={headerStyle}>Descripción</Typography>
                        </Grid>
                        <Grid item xs={3}>
                            <Typography variant="subtitle2" sx={headerStyle}>Tipo Importe</Typography>
                        </Grid>
                        <Grid item xs={3}>
                            <Typography variant="subtitle2" sx={headerStyle}>Cantidad Importe</Typography>
                        </Grid>
                        <Grid item xs={!readOnly && checkPermission(ADMIN_PROPOSAL_PROJECT) ? 2 : 3}>
                            <Typography variant="subtitle2" sx={headerStyle}>Periodo Tiempo</Typography>
                        </Grid>
                        {!readOnly && checkPermission(ADMIN_PROPOSAL_PROJECT) ? (
                            <Grid item xs={1} display="flex" justifyContent="center" alignItems="center">
                                <IconButton size="small" onClick={() => addRow(setSavingsRowsHw, { description: '', type: 'Único', quantity: '', period: '' })}>
                                    <AddCircleOutlineIcon color="primary" />
                                </IconButton>
                            </Grid>
                        ) : null}
                    </Grid>

                    {savingsRowsHw.map((row) => (
                        <Grid container spacing={2} key={row.id} mb={1}>
                            <Grid item xs={3}>
                            <SearchableSelect
                                options={[...allDescriptions.map((desc) => ({ value: desc })), { value: 'custom' }]}
                                value={row.description}
                                onChange={(e) => handleDescriptionChange(row.id, e.target.value, setSavingsRowsHw)}
                                disabled={readOnly}
                                placeholder="Seleccione una opción"
                                renderOption={(option) =>
                                    option.value === 'custom' ? <em>Escribir concepto</em> : option.value
                                }
                            />                             
                            </Grid>
                            <Grid item xs={3}>
                                <RadioGroup
                                    row
                                    value={row.type}
                                    onChange={(e) => {
                                        const newValue = e.target.value;
                                        handleSavingsRowChange(row.id, 'type', newValue, setSavingsRowsHw);
                                        // Si el tipo es UNIQUE, limpia el campo 'period'
                                        if (newValue === 'UNIQUE') {
                                            handleSavingsRowChange(row.id, 'period', '', setSavingsRowsHw);
                                        }
                                    }}   
                                >
                                    {typeImport.map((p) => (
                                        <FormControlLabel disabled={readOnly} key={p.key} value={p.key} control={<Radio />} label={p.value} />
                                    ))}
                                </RadioGroup>
                            </Grid>
                            <Grid item xs={3}>
                                <TextField
                                    fullWidth
                                    size="small"
                                    value={row.quantity}
                                    onChange={(e) => {
                                        const value = e.target.value;
                                        const floatValue = value === '' ? null : parseFloat(value) || 0;
                                        handleSavingsRowChange(row.id, 'quantity', floatValue, setSavingsRowsHw);
                                    }}
                                    placeholder="Escribe un número"
                                    inputProps={{
                                        inputMode: 'decimal', // Sugerencia de teclado numérico para dispositivos móviles
                                        pattern: "^\\d*\\.?\\d*$", // Correcta forma en cadenas JavaScript
                                    }}
                                    InputProps={{
                                        endAdornment: (
                                            <InputAdornment position="end">€</InputAdornment>
                                        ),
                                    }}
                                    disabled={readOnly}
                                />

                            </Grid>
                            <Grid item xs={readOnly ? 3 : 2}>
                                <Select
                                    fullWidth
                                    size="small"
                                    value={row.period}
                                    onChange={(e) => handleSavingsRowChange(row.id, 'period', e.target.value, setSavingsRowsHw)}
                                    disabled={row.type === 'UNIQUE' || readOnly}
                                >
                                    <MenuItem value=""><em>Seleccione una opción</em></MenuItem>
                                    {period.map((p) => (
                                        <MenuItem key={p.key} value={p.key}>{p.value}</MenuItem>
                                    ))}
                                </Select>
                            </Grid>
                            {!readOnly && checkPermission(ADMIN_PROPOSAL_PROJECT) && (
                            <Grid item xs={1} display="flex" justifyContent="center" alignItems="center">
                                <IconButton size="small" onClick={() => confirmDelete(row,'savingsHw')}>
                                    <DeleteIcon color="error" />
                                </IconButton>
                            </Grid>
                            )}
                        </Grid>
                    ))}
                </Paper>

                {/* Coste subcontratación */}
                <Typography variant="h6" mt={4} mb={2}>
                    Coste subcontratación
                </Typography>
                <Box sx={{ mb: 2, width: "100%", textAlign: "center", display: "flex", flexDirection: "column", alignItems: "center" }}>
                    <Tooltip
                        title={
                            <Box sx={{ p: 1 }}>
                                <Typography variant="text" sx={{ fontWeight: 'bold', mb: 0.5 }}>
                                    El objetivo de este bloque es registrar los costes de servicios subcontratados necesarios para la implementación del proyecto.
                                </Typography>
                                <br />
                                <br />
                                <Typography variant="text" sx={{ fontWeight: 'bold', mb: 0.5 }}>
                                    Ejemplo: Contratación de empresa consultora por 5.000€ o servicio de mantenimiento externo por 350€ al mes.
                                </Typography>
                                <br />
                                <br />
                                <Typography variant="text" sx={{ fontWeight: 'bold', mb: 0.5 }}>
                                    Información sobre los campos:
                                </Typography>
                                <ul style={{ margin: '0', paddingLeft: '16px' }}>
                                    <li><b>Descripción:</b> Nombre o descripción del servicio subcontratado</li>
                                    <li><b>Tipo Importe:</b> Si el coste es único o recurrente</li>
                                    <li><b>Cantidad Importe:</b> Valor económico del servicio</li>
                                    <li><b>Periodo Tiempo:</b> En caso de ser recurrente, frecuencia del pago</li>
                                </ul>
                            </Box>
                        }
                        arrow
                        placement="right"
                        sx={{ maxWidth: '400px' }}
                    >
                        <Box display="flex" alignItems="center" justifyContent="center">
                            <Typography variant="caption" color="primary">¿Tienes dudas?</Typography>
                            <IconButton size="small" color="primary">
                                <HelpOutlineIcon fontSize="small" />
                            </IconButton>
                        </Box>
                    </Tooltip>
                </Box>
                <Paper sx={{ p: 2, backgroundColor: '#e0f7fa', boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.1)' }}>
                    <Grid container spacing={2} mb={2}>
                        <Grid item xs={3}>
                            <Typography variant="subtitle2" sx={headerStyle}>Descripción</Typography>
                        </Grid>
                        <Grid item xs={3}>
                            <Typography variant="subtitle2" sx={headerStyle}>Tipo Importe</Typography>
                        </Grid>
                        <Grid item xs={3}>
                            <Typography variant="subtitle2" sx={headerStyle}>Cantidad Importe</Typography>
                        </Grid>
                        <Grid item xs={!readOnly && checkPermission(ADMIN_PROPOSAL_PROJECT) ? 2 : 3}>
                            <Typography variant="subtitle2" sx={headerStyle}>Periodo Tiempo</Typography>
                        </Grid>
                        {!readOnly && checkPermission(ADMIN_PROPOSAL_PROJECT) ? (
                            <Grid item xs={1} display="flex" justifyContent="center" alignItems="center">
                                <IconButton size="small" onClick={() => addRow(setSavingsRowsSub, { description: '', type: 'Único', quantity: '', period: '' })}>
                                    <AddCircleOutlineIcon color="primary" />
                                </IconButton>
                            </Grid>
                        ) : null}
                    </Grid>

                    {savingsRowsSub.map((row) => (
                        <Grid container spacing={2} key={row.id} mb={1}>
                            <Grid item xs={3}>
                            <SearchableSelect
                                options={[...allDescriptions.map((desc) => ({ value: desc })), { value: 'custom' }]}
                                value={row.description}
                                onChange={(e) => handleDescriptionChange(row.id, e.target.value, setSavingsRowsSub)}
                                disabled={readOnly}
                                placeholder="Seleccione una opción"
                                renderOption={(option) =>
                                    option.value === 'custom' ? <em>Escribir concepto</em> : option.value
                                }
                            />                             
                            </Grid>
                            <Grid item xs={3}>
                                <RadioGroup
                                    row
                                    value={row.type}
                                        onChange={(e) => {
                                            const newValue = e.target.value;
                                            handleSavingsRowChange(row.id, 'type', newValue, setSavingsRowsSub);
                                            if (newValue === 'UNIQUE') {
                                                handleSavingsRowChange(row.id, 'period', '', setSavingsRowsSub);
                                            }
                                        }}  
                                >
                                    {typeImport.map((p) => (
                                        <FormControlLabel disabled={readOnly} key={p.key} value={p.key} control={<Radio />} label={p.value} />
                                    ))}
                                </RadioGroup>
                            </Grid>
                            <Grid item xs={3}>
                                <TextField
                                    fullWidth
                                    size="small"
                                    value={row.quantity}
                                    onChange={(e) => {
                                        const value = e.target.value;
                                        const floatValue = value === '' ? null : parseFloat(value) || 0;
                                        handleSavingsRowChange(row.id, 'quantity', floatValue, setSavingsRowsSub);
                                    }}
                                    placeholder="Escribe un número"
                                    inputProps={{
                                        inputMode: 'decimal', // Sugerencia de teclado numérico para dispositivos móviles
                                        pattern: "^\\d*\\.?\\d*$", // Correcta forma en cadenas JavaScript
                                    }}
                                    InputProps={{
                                        endAdornment: (
                                            <InputAdornment position="end">€</InputAdornment>
                                        ),
                                    }}
                                    disabled={readOnly}
                                />

                            </Grid>
                            <Grid item xs={readOnly ? 3 : 2}>
                                <Select
                                    fullWidth
                                    size="small"
                                    value={row.period}
                                    onChange={(e) => handleSavingsRowChange(row.id, 'period', e.target.value, setSavingsRowsSub)}
                                    disabled={row.type === 'UNIQUE' || readOnly}
                                >
                                    <MenuItem value=""><em>Seleccione una opción</em></MenuItem>
                                    {period.map((p) => (
                                        <MenuItem key={p.key} value={p.key}>{p.value}</MenuItem>
                                    ))}
                                </Select>
                            </Grid>
                            {!readOnly && checkPermission(ADMIN_PROPOSAL_PROJECT) && (
                            <Grid item xs={1} display="flex" justifyContent="center" alignItems="center">
                                <IconButton size="small" onClick={() => confirmDelete(row,'savingsSub')}>
                                    <DeleteIcon color="error" />
                                </IconButton>
                            </Grid>
                            )}
                        </Grid>
                    ))}
                </Paper>                


                {/* Dialog para agregar un concepto */}
                <Dialog open={isDialogOpen} onClose={handleDialogClose}>
                    <DialogTitle>Escribir nuevo concepto</DialogTitle>
                    <DialogContent>
                        <TextField
                            fullWidth
                            value={newConcept}
                            onChange={(e) => setNewConcept(e.target.value)}
                            placeholder="Ingrese el nuevo concepto"
                        />
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={handleDialogClose}>Cancelar</Button>
                        <Button onClick={handleAddConcept} color="primary">
                            Agregar
                        </Button>
                    </DialogActions>
                </Dialog>

                    
                {renderActionButtons()}


                <Dialog open={openDialog} onClose={handleCloseDialog}>
                    <DialogTitle>Confirmar Eliminación</DialogTitle>
                    <DialogContent>
                        <DialogContentText>
                            ¿Estás seguro de que deseas eliminar?
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={handleCloseDialog} color="primary">
                            Cancelar
                        </Button>
                        <Button onClick={handleConfirmDelete} color="error">
                            Eliminar
                        </Button>
                    </DialogActions>
                </Dialog>
                
                {/* Dialog de Confirmación de Éxito */}
                <Dialog open={openSaveDialog} onClose={handleCloseSaveDialog}>
                    <DialogTitle>Guardado Exitoso</DialogTitle>
                    <DialogContent>
                        <DialogContentText>El proyecto ha sido guardado exitosamente.</DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={handleCloseSaveDialog} color="primary" autoFocus>
                            OK
                        </Button>
                    </DialogActions>
                </Dialog>


                <Dialog open={openDialogError} onClose={handleCloseDialog}>
                    <DialogTitle>Error</DialogTitle>
                    <DialogContent>
                        <DialogContentText>Se debe rellenar todos los datos.</DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={handleCloseDialog} color="primary" autoFocus>
                            OK
                        </Button>
                    </DialogActions>
                </Dialog>

                <DialogLoader open={sendingApiRequest} />
            </Box>
        </div>
    );
};

ThirdStep.propTypes = {
    idProposalProject: propTypes.number,
    savingsStaffProposalProject: propTypes.array,
    costITProposalProject: propTypes.array,
    reloadData: propTypes.func,
    readOnly: propTypes.bool,
    currentStatus: propTypes.string
};

export default ThirdStep;
